import { gql } from 'apollo-angular'

export default gql`
  query survey_test_get_related_entities {
    facility(order_by: { name: asc }) {
      id
      name
    }
    facility_room(order_by: { name: asc }) {
      id
      name
    }
    modality(order_by: { id: asc }) {
      id
    }
    scanner(order_by: { name: asc }) {
      id
      name
    }
    survey_test_routine(order_by: { name: asc }) {
      id
      name
    }
    user(order_by: { firstName: asc }, where: { status: { _neq: "deleted" } }) {
      id
      firstName
      lastName
    }
  }
`
